import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import qs from 'qs'

export const useQueryParam = (param: string): string => {
  const location = useLocation()
  return (useMemo(() => qs.parse(location.search, { ignoreQueryPrefix: true })[param], [location.search, param]) ||
    '') as string
}
